import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchAreasData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";

const useFetchAreasData = (
  companyId: string,
  structureId: string | undefined,
  query?: string,
  isEdit?: boolean
) => {
  const normalizedQuery = query?.trim();
  const filters = normalizedQuery
    ? `(${normalizedQuery
        .split(/\s+/)
        .map((word) => `areaName=like=*${word}*`)
        .join(";")})`
    : null;
  return useInfiniteQuery({
    queryKey: ["fetch-areas", companyId, structureId, query],
    queryFn: async ({ pageParam, signal }) => {
      const data = await fetchAreasData(companyId, structureId!, {
        signal,
        nextCursor: pageParam,
        query: filters,
      });
      return data;
    },
    enabled: !!companyId && !!structureId && !isEdit,
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor || null,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchAreasData;
